import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PublicSalesResponse } from '@web/shared/module/shop';

@jsonObject
export class PublicCosmeticBoxResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(PublicSalesResponse)
  public readonly sales!: PublicSalesResponse;
}
